import { Component } from '@angular/core'
import { RoutingService } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { BehaviorSubject, take } from 'rxjs'
import { CustomRoutes } from '../../../../../models/enum/custom-routes.enum'
import { DispenserAgreementService } from '../../../../../services/agreement/dispenser/dispenser-agreement.service'

@Component({
    selector: 'app-cancel-dispenser-agreement-modal',
    templateUrl: './cancel-dispenser-agreement-modal.component.html',
    styleUrl: './cancel-dispenser-agreement-modal.component.scss',
    standalone: false
})
export class CancelDispenserAgreementModalComponent {
  public isLoading$ = new BehaviorSubject(false)

  constructor(
    private launchDialogService: LaunchDialogService,
    private routingService: RoutingService,
    private dispenserAgreementService: DispenserAgreementService
  ) {}

  public dismissModal(): void {
    this.launchDialogService.closeDialog(null)
  }

  public cancelDispenserAgreement(): void {
    this.isLoading$ = new BehaviorSubject(true)

    this.launchDialogService.data$.pipe(take(1)).subscribe((agreementCode) => {
      this.dispenserAgreementService
        .cancelDispenserAgreement(agreementCode)
        .pipe(take(1))
        .subscribe({
          complete: () => {
            this.routingService.go({
              cxRoute: CustomRoutes.CANCEL_DISPENSER_AGREEMENT,
              params: { code: agreementCode }
            })
            this.dismissModal()
            this.isLoading$.next(false)
          }
        })
    })
  }
}
